/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { ConvertDatesToStrings } from '@itk/typescript-utils'
import type { Shared_PictureResolutions } from '../models/Shared_PictureResolutions';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ContactPersonPictureService {
    /**
     * @param resolution
     * @param contactPersonId
     * @returns string Success
     * @throws ApiError
     */
    public static getApiV1ContactPersonPictures(
        resolution?: ConvertDatesToStrings<Shared_PictureResolutions>,
        contactPersonId?: ConvertDatesToStrings<string>,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/contactPersonPictures',
            query: {
                'resolution': resolution,
                'contactPersonId': contactPersonId,
            },
        });
    }
    /**
     * @param contactPersonId
     * @param formData
     * @returns any Success
     * @throws ApiError
     */
    public static postApiV1ContactPersonPictures(
        contactPersonId?: ConvertDatesToStrings<string>,
        formData?: ConvertDatesToStrings<{
            ContentType?: string;
            ContentDisposition?: string;
            Headers?: Record<string, Array<string>>;
            Length?: number;
            Name?: string;
            FileName?: string;
        }>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/contactPersonPictures',
            query: {
                'contactPersonId': contactPersonId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param contactPersonId
     * @returns any Success
     * @throws ApiError
     */
    public static deleteApiV1ContactPersonPictures(
        contactPersonId?: ConvertDatesToStrings<string>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/contactPersonPictures',
            query: {
                'contactPersonId': contactPersonId,
            },
        });
    }
}
